import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReviewsRating = _resolveComponent("ReviewsRating")!
  const _component_ReviewsGlimpse = _resolveComponent("ReviewsGlimpse")!
  const _component_PortalBadges = _resolveComponent("PortalBadges")!
  const _component_WidgetReviewsAll = _resolveComponent("WidgetReviewsAll")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.reviewsWidget === 'widget-reviews-rating')
      ? (_openBlock(), _createBlock(_component_ReviewsRating, {
          key: 0,
          reviewsReferrer: _ctx.reviewsReferrer,
          organisationId: _ctx.organisationId
        }, null, 8 /* PROPS */, ["reviewsReferrer", "organisationId"]))
      : _createCommentVNode("v-if", true),
    (_ctx.reviewsWidget === 'widget-reviews-glimpse')
      ? (_openBlock(), _createBlock(_component_ReviewsGlimpse, {
          key: 1,
          reviewsReferrer: _ctx.reviewsReferrer,
          organisationId: _ctx.organisationId,
          isSmall: _ctx.isSmall
        }, null, 8 /* PROPS */, ["reviewsReferrer", "organisationId", "isSmall"]))
      : _createCommentVNode("v-if", true),
    (_ctx.reviewsWidget === 'widget-reviews-portal-badges-single')
      ? (_openBlock(), _createBlock(_component_PortalBadges, {
          key: 2,
          reviewsReferrer: _ctx.reviewsReferrer,
          organisationId: _ctx.organisationId,
          isSingleBadge: _ctx.isSingleBadge
        }, null, 8 /* PROPS */, ["reviewsReferrer", "organisationId", "isSingleBadge"]))
      : _createCommentVNode("v-if", true),
    (_ctx.reviewsWidget === 'widget-reviews-portal-badges-all')
      ? (_openBlock(), _createBlock(_component_PortalBadges, {
          key: 3,
          reviewsReferrer: _ctx.reviewsReferrer,
          organisationId: _ctx.organisationId,
          isSingleBadge: _ctx.isSingleBadge
        }, null, 8 /* PROPS */, ["reviewsReferrer", "organisationId", "isSingleBadge"]))
      : _createCommentVNode("v-if", true),
    (_ctx.reviewsWidget === 'widget-reviews-all')
      ? (_openBlock(), _createBlock(_component_WidgetReviewsAll, {
          key: 4,
          reviewsReferrer: _ctx.reviewsReferrer,
          organisationId: _ctx.organisationId,
          isOpen: _ctx.isOpen
        }, null, 8 /* PROPS */, ["reviewsReferrer", "organisationId", "isOpen"]))
      : _createCommentVNode("v-if", true)
  ]))
}